module.exports = __webpack_public_path__ + "static/use-case-4-content-5-68a01ac2d4260596fcb13abc66a5a233.png";